(function () {
    angular.module('tmx-app').controller('CustomerEtbController', ['$scope', 'lookupService','$mdDialog', 'TMX_FINANCE_CONSTANTS', 'cacheStore', 'tmxResource', 'ToastService', 'tmxUtility', 'LoanApplicationService','dynamicFormService','BroadcastService',

        function CustomerEtbController($scope, lookupService,$mdDialog, TMX_FINANCE_CONSTANTS, cacheStore, tmxResource, ToastService, tmxUtility, LoanApplicationService,dynamicFormService,BroadcastService) {
            var CustomerEtbVM = $scope;
            var lkupType = TMX_FINANCE_CONSTANTS.LOOKUP_TYPES;
            var FgitSocket = null;
            var ws = null;
            CustomerEtbVM.isPageLoading= false;
            //var IsETBSuccessful = dynamicFormService.applicationData.TmxCustomerMaster[0].ETBFetchFlag;
            CustomerEtbVM.IdentifierLkpValue = dynamicFormService.applicationData.TmxCustomerMaster[0].NationalIdTypeLkp;
            CustomerEtbVM.idvalue = dynamicFormService.applicationData.TmxCustomerMaster[0].NationalIdentifierValue;
            //CustomerEtbVM.IdentifierLkp = lookupService.getLocalLookupsByType(lkupType.ID_TYPE);
            angular.forEach(CustomerEtbVM.IdentifierLkp, function (item) {
                if (item.LookupId == CustomerEtbVM.IdentifierLkpValue && item.VisibleValue == "NIC Number (ID-N)") {
                    if (angular.isDefined(CustomerEtbVM.IdentifierLkpValue) && CustomerEtbVM.IdentifierLkpValue != null && CustomerEtbVM.IdentifierLkpValue != "") {
                        CustomerEtbVM.cnic = CustomerEtbVM.IdentifierLkpValue;
                    }
                }
            });
            CustomerEtbVM.disablebutton = function () {
                if (angular.isDefined(CustomerEtbVM.AreaLkpValue) && CustomerEtbVM.AreaLkpValue != null && angular.isDefined(CustomerEtbVM.cnic) && CustomerEtbVM.cnic != "" && angular.isDefined(CustomerEtbVM.IndexLkpValue) && CustomerEtbVM.IndexLkpValue != "") {
                    return false;
                }
                else
                    return true;
            }
            CustomerEtbVM.getETB =function() {
                if (CustomerEtbVM.IdentifierLkpValue && CustomerEtbVM.idvalue) {
                    $scope.cnic = CustomerEtbVM.idvalue;
                    CustomerEtbVM.etbClicked = true;
                    tmxResource('Integration').getByAction('GetETB/' + CustomerEtbVM.idvalue, true, 'get').then(function (response) {
                        //Added by Adeel 07-01-2020
                        //CustomerEtbVM.IsETBSuccessful = true;

                        if (response.data.length > 0) {
                            CustomerEtbVM.customerMasterList = angular.copy(response.data);
                            CustomerEtbVM.customerMasterList.sort(function (obj1, obj2) {

                                if (obj1.TmxCustomerDetail.length > 0 && obj2.TmxCustomerDetail.length > 0) {
                                    var date1 = new Date(obj1.TmxCustomerDetail[0].RelationWithBanks);
                                    var date2 = new Date(obj2.TmxCustomerDetail[0].RelationWithBanks);
                                    if (date1 > date2) return -1;
                                    if (date1 < date2) return 1;

                                }
                                return 0;
                            })


                        }
                        else {
                            CustomerEtbVM.customerMasterList = [];
                            ToastService.showCustomToast("default", "No record found");
                            return;
                        }
                    })

                }
                else {
                    ToastService.showCustomToast("default", "Please Enter Identifier type & Value");
                }
            }

            CustomerEtbVM.viewETBCustomerDetail = function (index) {

                $mdDialog.show({
                    controller: ['$mdDialog', '$scope', 'customerMasterData', 'lookupService', 'TMX_FINANCE_CONSTANTS', CustomerDetailDialogController],
                    locals: { customerMasterData: CustomerEtbVM.customerMasterList[index] },
                    templateUrl: 'app/private/transaction/loan-application/add/view-customer-detail.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                    .then(function () {

                    }, function () {

                    });
            }
            function CustomerDetailDialogController($mdDialog, $scope, customerMasterData, lookupService, TMX_FINANCE_CONSTANTS) {
                $scope.vm = {};

                var lkupType = TMX_FINANCE_CONSTANTS.LOOKUP_TYPES;

                var addressTypeLkp = lookupService.getLocalLookupsByType(lkupType.ADDRESS_TYPE);
                var PermanentAddressId = 0;
                var CurrentResidenceAddressId = 0;

                var PERMANENT_ADDRESS = addressTypeLkp.filter(function (item) {
                    return item.HiddenValue == 'PERMANENT';
                });

                var TEMPORARY_ADDRESS = addressTypeLkp.filter(function (item) {
                    return item.HiddenValue == 'TEMPORARY';
                });

                if (PERMANENT_ADDRESS.length)
                    PermanentAddressId = PERMANENT_ADDRESS[0].LookupId;
                if (TEMPORARY_ADDRESS.length)
                    CurrentResidenceAddressId = TEMPORARY_ADDRESS[0].LookupId;

                if (customerMasterData.TmxCustomerDetail[0].TmxPerson) {
                    $scope.PermanentAddressIndex = customerMasterData.TmxCustomerDetail[0].TmxPerson.TmxPersonToAddressMapping.map(function (item) { return item.AddressTypeLkp; }).indexOf(PermanentAddressId);
                    $scope.CurrentResidenceAddressIndex = customerMasterData.TmxCustomerDetail[0].TmxPerson.TmxPersonToAddressMapping.map(function (item) { return item.AddressTypeLkp; }).indexOf(CurrentResidenceAddressId);
                }

                $scope.vm = customerMasterData;
                $scope.vm.isUbankTenant = CustomerEtbVM.isUbankTenant;
                $scope.vm.formatDate = CustomerEtbVM.formatDate;
                $scope.ok = function () {
                    $mdDialog.hide();
                };

                $scope.cancel = function () {
                    $mdDialog.hide();
                };
            }
            CustomerEtbVM.etbRadioButtonChange = function (index) {

                if (index != 'null') {
                    //CustomerEtbVM.customerMasterList[index].ExistingCustomer = 8;

                    CustomerEtbVM.newCustomer = false;
                    CustomerEtbVM.IsETBSuccessful = true;
                    dynamicFormService.applicationData.TmxCustomerMaster[0].ETBFetchFlag = 1;
                    dynamicFormService.applicationData.TmxCustomerMaster[0].NationalIdTypeLkp =CustomerEtbVM.IdentifierLkpValue;
                    dynamicFormService.applicationData.TmxCustomerMaster[0].NationalIdentifierValue = CustomerEtbVM.idvalue;
                    dynamicFormService.applicationData.TmxCustomerMaster[0].CustomerCode = CustomerEtbVM.customerMasterList[index].CustomerCode;
                    dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerExistingLoan = CustomerEtbVM.customerMasterList[index].TmxCustomerExistingLoan;
                    BroadcastService.publish('reloadCustomerData', "");
                   
                }
            }

            CustomerEtbVM.formatDate = function (dateTime) {
                if (dateTime) {
                    // var date= new Date(dateTime + 'Z');
                    var date = new Date(dateTime);
                    var month = ('0' + (date.getUTCMonth() + 1)).slice(-2); //months from 1-12
                    var day = ('0' + (date.getUTCDate() + 1)).slice(-2);
                    var year = date.getUTCFullYear();
                    return day + "-" + month + "-" + year;
                }
                else {
                    return 'N/A';
                }
            }
            
            function InitilizeData() {
                CustomerEtbVM.IdentifierLkp = lookupService.getLocalLookupsByType(lkupType.ID_TYPE);
                if(dynamicFormService.applicationData.TmxCustomerMaster[0].ETBFetchFlag && dynamicFormService.applicationData.TmxCustomerMaster[0].ETBFetchFlag==1)
                {
                    ToastService.showCustomToast("Success", "ETB is already performed");
                    CustomerEtbVM.IsETBSuccessful = true;
                    return;
                }
            }

            (function InitializePage() {
                InitilizeData();
            })();

            $scope.$on('$destroy', function () {
                try{
                    if (tmxUtility.exists(ws)) {
                        ws.onclose = function () {};
                        ws.close();
                        ws = null;
                    }
                }
                catch(exception){
                    console.log(exception);
                }
            });
        }]);
})();